import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import endPoints from "networking/endPoints";
import auth_axios from "networking/AuthAxios";
import fast_auth_axios, { FAST_API_ENDPOINT } from "networking/FastAuthAxios";

const axiosBaseQuery =
  ({ baseUrl } = { baseUrl: "" }) =>
  async ({ url, method, body, params, fast }) => {
    try {
      // `fast: true` routes the endpoint to the FastAPI backend instead of Django.
      const result = fast
        ? await fast_auth_axios({ url: FAST_API_ENDPOINT + url, method, data: body, params })
        : await auth_axios({ url: baseUrl + url, method, data: body, params });
      return { data: result };
    } catch (err) {
      return { data: err.response };
    }
  };

export const dashboardSlice = createApi({
  reducerPath: "dashboardData",
  baseQuery: axiosBaseQuery({
    baseUrl: process.env.REACT_APP_API_ENDPOINT,
    prepareHeaders: (headers) => {
      headers.set("Authorization", `Bearer ${localStorage.getItem("token")}`);
      return headers;
    },
  }),
  tagTypes: ["dashboard"],

  endpoints: (builder) => ({
    getDashBoardData: builder.query({
      query: () => {
        return {
          url: endPoints.DASHBOARD,
          method: "get",
          fast: true,
        };
      },
    }),

    showAssigndTask: builder.query({
      query: (params) => {
        return {
          url: endPoints.ASSIGNTASK,
          method: "get",
          params: { ...params },
          fast: true,
        };
      },
      providesTags: ["dashboard"],
    }),

    completeAssigndTask: builder.mutation({
      query: (params) => {
        let { id, taskId } = params;
        return {
          url: endPoints.TASKSCOMPLETE(id, taskId),
          method: "post",
        };
      },
      invalidatesTags: ["dashboard"],
    }),
  }),
});

export const { useGetDashBoardDataQuery, useShowAssigndTaskQuery, useCompleteAssigndTaskMutation } = dashboardSlice;
